import React from 'react'
import { OnClickMenu, OnClickMenuItem } from 'uiComponents/menus'
import { LucideIcon } from 'utils/lucideIcon'
import './discountsHeader.scss'
import SearchBar from 'uiComponents/search/searchBar'
import { NavigationTabs } from 'uiComponents/navigation/tabs'
import { useLocation, useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import { history } from 'middleware'
import { isLocalStorageAvailable } from 'utils/storage'

interface DiscountsHeaderProps {
    onClickNewDiscount: () => void
    onClickNewDiscountPool: () => void
}

export const DiscountsHeader = ({ onClickNewDiscount, onClickNewDiscountPool }: DiscountsHeaderProps) => {
    const location = useLocation()
    const activeTab = location.pathname.includes('/pools') ? 'pools' : 'codes'
    const searchByOptions = [
        { value: 'code', name: 'Code' },
        { value: 'discount_reservoir_name', name: 'Pool name' },
        { value: 'product_id', name: 'Product ID' },
        { value: 'order_number', name: 'Order number' },
        { value: 'validity_date', name: 'Booking window', inputType: 'date' },
    ]
    const routeParams = useParams<BaseRouteParams>()
    const basePath = `/account/${routeParams.accountSlug}/discounts`

    let defaultSearchBy = 'discount_reservoir_name'
    let autoSearchByPatterns
    if (activeTab === 'codes') {
        defaultSearchBy = 'code'
        if (isLocalStorageAvailable()) {
            defaultSearchBy = localStorage.getItem('discounts_search_by') ?? defaultSearchBy
        }
        autoSearchByPatterns = [
            [/^\d{8,9}$/, 'order_number'],
            [/^\d{4}$/, 'product_id'],
        ] as [RegExp, string][]
    }

    const onSearchByChange = (searchBy: string) => {
        if (searchBy === 'discount_reservoir_name') {
            history.push(`${basePath}/pools`)
        } else {
            if (isLocalStorageAvailable()) {
                localStorage.setItem('discounts_search_by', searchBy)
            }
            history.push(`${basePath}/codes`)
        }
    }

    return (
        <div className="discount-header-container">
            <div className="column">
                <SearchBar
                    searchByOptions={searchByOptions}
                    defaultSearchBy={defaultSearchBy}
                    autoSearchByPatterns={autoSearchByPatterns}
                    onSearchByChange={onSearchByChange}
                    placeholder="Search..."
                    showClearButton
                />
            </div>
            <div className="column">
                <NavigationTabs
                    tabs={[
                        {
                            current: activeTab === 'pools',
                            name: 'Pools',
                            onClick: () => {
                                history.push(`${basePath}/pools`)
                            },
                        },
                        {
                            current: activeTab === 'codes',
                            name: 'Codes',
                            onClick: () => {
                                history.push(`${basePath}/codes`)
                            },
                        },
                    ]}
                />
            </div>
            <div className="column">
                <OnClickMenu title="Create" className="create" size="large">
                    <OnClickMenuItem onClick={onClickNewDiscount}>
                        <LucideIcon iconName="Tag" />
                        New discount
                    </OnClickMenuItem>
                    <OnClickMenuItem onClick={onClickNewDiscountPool}>
                        <LucideIcon iconName="Tags" />
                        New discount pool
                    </OnClickMenuItem>
                </OnClickMenu>
            </div>
        </div>
    )
}
